// extracted by mini-css-extract-plugin
module.exports = {"notesWrapper":"NotesHistory_notesWrapper__uL5uB","singleHistory":"NotesHistory_singleHistory__2-NlS","attachment":"NotesHistory_attachment__PAjis"};